module.exports = "hr {\n  margin-top: 5px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #eee; }\n"